// Koden i denne filen vil lastes inn på hver side på nettstedet ditt

$w.onReady(function () {Write});